export class XModel {
  constructor() {
    this.id = "";
    this.createdAt = new Date(0);
    this.updatedAt = new Date(0);
  }
}
